<template>
	<v-container>
		<v-alert type="error" v-show="showAlertIntegrator">
			{{ txt.alert.integrator }}
		</v-alert>
		<form>
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-model="formState.selectedIntegrator"
						:items="formItems.integrator"
						hide-selected
						label="Integrator System"
						persistent-hint
						chips
						return-object
					></v-autocomplete>
				</v-col>
				<v-col cols="12" md="12">
					<date-picker
						label="Date"
						:date.sync="formState.selectedDate"
						:menu.sync="menuFrom"
					/>
				</v-col>
			</v-row>
			<v-btn
				:disabled="loading"
				class="searchButton ml-5"
				color="primary"
				@click="loadData"
				>{{ txt.button.load }}
			</v-btn>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'
import DatePicker from '../arcCustom/DatePicker.vue'

export default {
	components: { DatePicker },
	name: 'IntegratorStateFilters',
	props: {
		loading: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	data() {
		return {
			txt: {
				button: {
					load: 'Load Information',
				},
				alert: {
					integrator: 'Please select one integrator system',
				},
			},
			formState: {
				selectedIntegrator: null,
				selectedDate: new Date().toISOString().substr(0, 10),
			},
			formItems: {
				integrator: [],
			},
			menuFrom: false,
			showAlertIntegrator: false,
		}
	},
	methods: {
		async getIntegratorSystems() {
			try {
				this.$emit('startLoading')
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/integrator-state-tool/integrator`)
				this.$data.formItems.integrator = res.data
			} catch (err) {
				console.log(err)
			} finally {
				this.$emit('endLoading')
			}
		},
		loadData() {
			if (!this.formState.selectedIntegrator) {
				this.showAlertIntegrator = true
				return
			}
			this.showAlertIntegrator = false
			const params = {
				integrator: this.formState.selectedIntegrator,
				selectedDate: this.formState.selectedDate,
			}
			this.$emit('loadData', params)
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getIntegratorSystems()
		})
	},

}
</script>

<style>

</style>
